import { Link } from 'react-router-dom';
import { useSiteContent } from '../content/ContentContext';

export default function Footer() {
  const {
    content: { navItems, site },
  } = useSiteContent();

  return (
    <footer className="bg-[#123018] text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-3 lg:px-8">
        <div>
          <img src="/images/logo.jpg" alt={site.businessName} className="mb-4 h-16 w-auto rounded-md bg-white p-1" />
          <p className="max-w-sm text-sm leading-7 text-white/80">{site.footerDescription}</p>
        </div>
        <div>
          <h3 className="mb-4 text-lg font-bold">Quick Links</h3>
          <div className="grid gap-2 text-sm">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path} className="text-white/80 transition hover:text-white">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h3 className="mb-4 text-lg font-bold">Contact</h3>
          <div className="space-y-2 text-sm text-white/80">
            <p>{site.phoneDisplay}</p>
            <p>{site.email}</p>
            <p>{site.serviceArea}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 py-4 text-center text-sm text-white/70">
        &copy; {site.copyrightYear} {site.businessName}. All rights reserved.
      </div>
    </footer>
  );
}
